import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from "react-i18next";

export default function Honorees({honorees}){
  const history = useHistory();
  const {t} = useTranslation('common');
  return (
    <div className="central-meta">
      <div className="editing-info">
        <h5 className="f-title"><i className="fa fa-users" /> {t('groups.honorees')}</h5>

            <div className="photos-container small avatars">
              {
                (!honorees || !honorees.length) &&
                <center>
                  <div className="photos-empty"> {t('groups.noHonoreesDisplay')} </div>
                </center>
              }

              {
                honorees && honorees.map((p,i) => {
                  return (
                    <div className="photos-holder" key={i}>
                      <div
                        className="photos-item"
                        style={{backgroundImage: `url("${p.image}")`}}
                        onClick={()=> p.link && history.push({pathname: p.link})}
                        title={p.text}
                      />
                      <div>{p.text}</div>
                    </div>
                  )
                })
              }
            </div>

      </div>
    </div>
  );
}
